<template>
  <div id="footer" class="container-fluid">
    <div class="footer-container hidden-xs">
      <div class="footer-section">
        <div class="flex_tb_c image">
          <img style="width: auto;" src="@/assets/img/qilin_logo.png" alt="">
          <img class="wechat-qr" src="@/assets/img/WeChat.png" alt="微信二维码">
        </div>
      </div>
      <div class="footer-section">
        <p class="footer-section-title">产品与服务</p>
        <div class="flex_tb">
          <router-link v-for="(item, index) in customerList" :key="index" :to=item.path class="service-link">
            <span @click="toServiceDetail(item)">{{ item.title }}</span>
          </router-link>
        </div>
      </div>
      <div class="footer-section">
        <p class="footer-section-title">分子实验</p>
        <div class="flex_tb">
          <router-link v-for="(item, index) in customerList2" :key="index" :to=item.path class="service-link">
            <span @click="toMolecularExperimentsServiceDetail(item)">{{ item.title }}</span>
          </router-link>
        </div>
      </div>
      <div class="footer-section">
        <p class="footer-section-title">联系我们</p>
        <div class="flex_tb">
          <p class="address_tel_fax">
            <span>地址：中国（四川）成都东部新区养马街道石养路2号7栋（属简州新城范围内）</span>
          </p>
          <p class="address_tel_fax">
            <span>邮箱：huangqy_ql@sina.com</span>
          </p>
          <p class="address_tel_fax">
            <span>微信号：think-more-see-all</span>
          </p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p class="copyright-line">
        <span class="copy">Copyright &copy; 2021 - {{ new Date().getFullYear() }} 成都启林未来科技有限公司</span>
        <span class="copy separator">|</span>
        <a href="https://beian.miit.gov.cn" class="copy">蜀ICP备2024067583号-1</a>
      </p>
    </div>
    <div class="footer-container-m visible-xs">
      <div class="footer-section">
        <div class="flex_tb_c image">
          <img style="width: auto;" src="@/assets/img/qilin_logo.png" alt="">
          <img class="wechat-qr" src="@/assets/img/WeChat.png" alt="微信二维码">
        </div>
      </div>
      <div class="footer-section">
        <p class="footer-section-title">联系我们</p>
        <div class="contact-info">
          <p class="address_tel_fax">
            <i class="contact-icon">📍</i>
            地址：中国（四川）成都东部新区养马街道石养路2号7栋（属简州新城范围内）
          </p>
          <p class="address_tel_fax">
            <i class="contact-icon">✉️</i>
            邮箱：huangqy_ql@sina.com
          </p>
          <p class="address_tel_fax">
            <i class="contact-icon">💬</i>
            微信号：think-more-see-all
          </p>
        </div>
      </div>
      <div class="footer-bottom">
        <p class="copyright-line">
          <span class="copy">Copyright &copy; 2021 - {{ new Date().getFullYear() }} 成都启林未来科技有限公司</span>
          <a href="https://beian.miit.gov.cn" class="copy">蜀ICP备2024067583号-1</a>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import omicsServices from "../data/omicsServices.json";
export default {
  name: "Footer",
  data() {
    return {
      serviceList: omicsServices.serviceList,
      unicellularServiceList: omicsServices.unicellularServiceList,
      MolecularExperimentsList: omicsServices.MolecularExperimentsList,
      customerList: [
        {
          logo: require("@/assets/serverImg/danxibao.png"),
          title: "单细胞",
          content: "10X 单细胞转录组、空间转录组",
          value: "单细胞"
        },
        {
          logo: require("@/assets/serverImg/zhuanluzu.png"),
          title: "转录组",
          content: "真核有参、真核无参测序，Small RNA、LnCRNA、CircRNA测序",
          value: "转录组"
        },
        {
          logo: require("@/assets/serverImg/weishenwu.png"),
          title: "微生物组",
          content: "宏转录组、宏基因组测序，扩增子/功能基因测序，群落多样性组成谱测序",
          value: "微生物组"
        },
        {
          logo: require("@/assets/serverImg/biaoxianjiyin.png"),
          title: "表现基因学",
          content: "Cut&Tag-seq、ChIP-Seg、全基因组甲基化测序",
          value: "表现基因学"
        },
        {
          logo: require("@/assets/serverImg/daixiedanbai.png"),
          title: "蛋白代谢检测",
          content: "非靶向代谢组、靶向代谢组、4D-DIA定量蛋白组",
          value: "蛋白代谢检测"
        }
      ],
      customerList2: [
        {
          logo: require("@/assets/serverImg/danxibao.png"),
          title: "分子实验",
          content: "分子实验",
          value: "常规分子实验"
        }
      ],
    };
  },
  created() {
    let list = [...this.serviceList, ...this.unicellularServiceList]
    for (const customer of this.customerList) {
      let index = list.findIndex(x => x.title == customer.value)
      customer["index"] = index
      customer["path"] = list[index].children[0].path
    }
    let list2 = [...this.MolecularExperimentsList]
    for (const customer of this.customerList2) {
      let index = list2.findIndex(x => x.title == customer.value)
      customer["index"] = index
      customer["path"] = list[index].children[0].path
    }
  },
  methods: {
    toServiceDetail(item) {
      let list = [...this.serviceList, ...this.unicellularServiceList]
      sessionStorage.setItem("serverItem", JSON.stringify(list[item.index]))
      sessionStorage.setItem("serverChild", JSON.stringify(list[item.index].children[0]))
      this.$store.commit('setNavName', "首页");
      setTimeout(() => {
        this.$store.commit('setNavName', '组学服务');
      }, 100)
    },
    toMolecularExperimentsServiceDetail(item) {
      let list = [...this.MolecularExperimentsList]
      sessionStorage.setItem("serverItem", JSON.stringify(list[item.index]))
      sessionStorage.setItem("serverChild", JSON.stringify(list[item.index].children[0]))
      this.$store.commit('setNavName', "首页");
      setTimeout(() => {
        this.$store.commit('setNavName', '分子实验');
      }, 100)
    },
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  color: var(--text-primary);
  background: var(--bg-secondary);
  overflow: hidden;
  flex-shrink: 0;
  padding: 40px 0 20px;
  border-top: 1px solid var(--border-color);
}

#footer .footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 30px;
  max-width: 1600px;
  margin: 0 auto;
  gap: 20px;
}

#footer .footer-container .footer-section {
  flex: 1;
  min-width: 200px;
}

#footer .footer-container .footer-section:last-child {
  min-width: 400px;
  flex: 1.5;
}

#footer .footer-container .image {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  min-width: 200px;
}

#footer .footer-container .image>img:not(.wechat-qr) {
  height: 45px;
  transition: transform 0.3s ease;
}

#footer .footer-container .image>img:not(.wechat-qr):hover {
  transform: scale(1.05);
}

#footer .footer-container .wechat-qr {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

#footer .footer-container .wechat-qr:hover {
  transform: scale(1.05);
}

.flex_tb_c {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex_tb {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 15px;
}

.footer-section-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--text-primary);
  position: relative;
  padding-bottom: 10px;
}

.footer-section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 3px;
  background-color: #10ccd2;
  border-radius: 2px;
}

.address_tel_fax {
  display: flex;
  justify-content: flex-start;
  color: var(--text-secondary);
  font-size: 14px;
  width: 100%;
  transition: color 0.3s ease;
  line-height: 1.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address_tel_fax:hover {
  color: var(--primary-color);
}

.service-link {
  color: var(--text-secondary);
  font-size: 14px;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 12px;
}

.service-link:hover {
  color: var(--primary-color);
  transform: translateX(5px);
}

.service-link::before {
  content: '•';
  position: absolute;
  left: 0;
  top: 0;
  color: var(--primary-color);
  font-size: 16px;
}

.footer-bottom {
  max-width: 1200px;
  margin: 30px auto 0;
  padding-top: 15px;
  border-top: 1px solid var(--border-color);
  text-align: center;
  padding: 15px 30px 0;
}

.copy {
  color: var(--text-secondary);
  font-size: 14px;
  margin-top: 10px;
}

.copy a {
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.3s ease;
}

.copy a:hover {
  color: var(--primary-color);
}

.copyright-line {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  flex-wrap: wrap;
  width: 100% !important;
  margin-top: 10px;
}

.copyright-line .copy {
  white-space: normal;
  display: inline-block;
  margin-top: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.separator {
  color: var(--text-tertiary);
  margin: 0 5px;
  white-space: nowrap;
}

.icp-link {
  color: var(--text-secondary);
  text-decoration: none;
  transition: color 0.3s ease;
  white-space: nowrap;
  display: inline-block;
}

.icp-link:hover {
  color: var(--primary-color);
}

/* 移动端样式 */
#footer .footer-container-m {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 0 15px;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

#footer .footer-container-m .footer-section {
  width: 100%;
  max-width: 100%;
  text-align: center;
  padding: 15px;
  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-primary) 100%);
  border-radius: 12px;
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-color);
  transition: all 0.3s ease;
  box-sizing: border-box;
}

#footer .footer-container-m .footer-section:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-3px);
}

#footer .footer-container-m .image {
  gap: 25px;
  padding: 25px 0;
  background: transparent;
  box-shadow: none;
  border: none;
}

#footer .footer-container-m .image>img:not(.wechat-qr) {
  height: 50px;
  transition: transform 0.3s ease;
}

#footer .footer-container-m .image>img:not(.wechat-qr):hover {
  transform: scale(1.05);
}

#footer .footer-container-m .wechat-qr {
  width: 120px;
  height: 120px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 3px solid var(--bg-primary);
}

#footer .footer-container-m .wechat-qr:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
}

#footer .footer-container-m .footer-section-title {
  text-align: center;
  align-self: center;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
  color: var(--text-primary);
  position: relative;
  padding-bottom: 12px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

#footer .footer-container-m .footer-section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 100%);
  border-radius: 2px;
}

#footer .footer-container-m .flex_tb {
  align-items: center;
  text-align: center;
  gap: 15px;
}

#footer .footer-container-m .address_tel_fax {
  justify-content: center;
  font-size: 14px;
  width: 100%;
  line-height: 1.6;
  padding: 0 15px;
  color: var(--text-secondary);
  transition: all 0.3s ease;
  border-radius: 8px;
  padding: 10px 15px;
  background: rgba(255, 255, 255, 0.8);
}

#footer .footer-container-m .address_tel_fax:hover {
  color: var(--primary-color);
  background: rgba(16, 204, 210, 0.1);
  transform: translateY(-2px);
}

#footer .footer-container-m .service-link {
  padding-left: 0;
  color: var(--text-secondary);
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  padding: 12px 20px;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid var(--border-light);
}

#footer .footer-container-m .service-link:hover {
  color: var(--primary-color);
  background: rgba(16, 204, 210, 0.1);
  box-shadow: 0 4px 12px rgba(16, 204, 210, 0.2);
  transform: translateY(-3px);
  border-color: var(--primary-color);
}

#footer .footer-container-m .service-link::before {
  display: none;
}

#footer .footer-container-m .copy {
  font-size: 13px;
  text-align: center;
  color: var(--text-secondary);
  line-height: 1.5;
}

#footer .footer-container-m .copyright-line {
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  box-shadow: var(--shadow-sm);
  width: 100%;
  box-sizing: border-box;
}

#footer .footer-container-m .footer-bottom {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid var(--border-color);
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
}

#footer .footer-container-m .copyright-line .copy {
  white-space: normal;
  display: block;
  margin-top: 5px;
  font-size: 12px;
}

#footer .footer-container-m .copyright-line .separator {
  display: none;
}

#footer .footer-container-m .contact-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px;
  width: 100%;
  box-sizing: border-box;
}

#footer .footer-container-m .contact-info .address_tel_fax {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  justify-content: flex-start;
  text-align: left;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text-secondary);
  transition: all 0.3s ease;
  border-radius: 6px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid var(--border-color);
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  box-sizing: border-box;
  width: 100%;
}

#footer .footer-container-m .contact-info .address_tel_fax:hover {
  color: var(--primary-color);
  background: rgba(16, 204, 210, 0.1);
  border-color: var(--primary-color);
  transform: translateX(5px);
}

#footer .footer-container-m .contact-icon {
  font-size: 16px;
  margin-top: 2px;
  flex-shrink: 0;
  width: 20px;
  text-align: center;
}

/* 响应式设计 */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #footer {
    padding: 50px 0 25px;
  }
  
  #footer .footer-container {
    padding: 0 30px;
    gap: 30px;
  }

  #footer .footer-container .image>img {
    height: 40px;
  }

  .footer-section-title {
    font-size: 17px;
    margin-bottom: 15px;
  }

  .address_tel_fax {
    font-size: 13px;
  }

  .service-link {
    font-size: 13px;
  }

  .copy {
    font-size: 13px;
  }
}

@media screen and (max-width: 767px) {
  #footer {
    padding: 40px 0 20px;
  }

  #footer .footer-container {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 30px;
  }

  #footer .footer-container .footer-section {
    width: 100%;
  }

  #footer .footer-container .flex_tb {
    align-items: center;
  }

  #footer .footer-container .address_tel_fax {
    justify-content: center;
    width: 100%;
  }

  #footer .footer-container .footer-section-title {
    align-self: center;
  }

  #footer .footer-container .footer-section-title::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .footer-bottom {
    margin-top: 30px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue